import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth.store';

export function useAuth() {
  const {
    user,
    accessToken,
    isAuthenticated,
    isLoading,
    setUser,
    setToken,
    logout,
    initialize,
  } = useAuthStore();

  useEffect(() => {
    if (accessToken && !user && isLoading) {
      initialize();
    }
    if (!accessToken && isLoading) {
      initialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isAdmin = user?.app_role === 'admin';

  const activeWorkspacePermissions = (() => {
    if (!user?.workspaces || user.workspaces.length === 0) return null;
    const savedId = localStorage.getItem('active_workspace_id');
    const ws = user.workspaces.find((w) => w.id === savedId) || user.workspaces[0];
    return ws?.permissions || null;
  })();

  const activeWorkspaceRole = (() => {
    if (!user?.workspaces || user.workspaces.length === 0) return null;
    const savedId = localStorage.getItem('active_workspace_id');
    const ws = user.workspaces.find((w) => w.id === savedId) || user.workspaces[0];
    return ws?.role || null;
  })();

  const hasPermission = (permission: string): boolean => {
    if (!user) return false;
    if (isAdmin) return true;
    if (activeWorkspaceRole === 'owner' || activeWorkspaceRole === 'admin') return true;
    if (!activeWorkspacePermissions) return false;
    return !!(activeWorkspacePermissions as unknown as Record<string, boolean>)[permission];
  };

  const hasAnyPermission = (permissions: string[]): boolean => {
    return permissions.some((p) => hasPermission(p));
  };

  return {
    user,
    accessToken,
    isAuthenticated,
    isLoading,
    isAdmin,
    activeWorkspacePermissions,
    activeWorkspaceRole,
    hasPermission,
    hasAnyPermission,
    setUser,
    setToken,
    logout,
    initialize,
  };
}
